import { defineMessages } from "react-intl";

export default defineMessages({
  oiva: {
    id: "common.oiva",
    defaultMessage: "Oiva"
  },
  statistics: {
    id: "common.statistics",
    defaultMessage: "Tilastot"
  },
  sivukartta: {
    id: "common.sivukartta",
    defaultMessage: "Sivukartta"
  },
  applyFor: {
    id: "common.applyFor",
    defaultMessage: "Haettava"
  },
  applyFor2: {
    id: "common.applyFor2",
    defaultMessage: "Uusi enimmäismäärä"
  },
  difference: {
    id: "common.difference",
    defaultMessage: "Muutos"
  },
  undo: {
    id: "common.undo",
    defaultMessage: "Kumoa muutokset"
  },
  changesText: {
    id: "common.changesText",
    defaultMessage: "Muutokset:"
  },
  loading: {
    id: "common.loading",
    defaultMessage: "Ladataan"
  },
  ok: {
    id: "common.ok",
    defaultMessage: "Ok"
  },
  yes: {
    id: "common.yes",
    defaultMessage: "Kyllä"
  },
  no: {
    id: "common.no",
    defaultMessage: "Ei"
  },
  clear: {
    id: "common.clear",
    defaultMessage: "Tyhjennä"
  },
  cancel: {
    id: "common.cancel",
    defaultMessage: "Peruuta"
  },
  accept: {
    id: "common.accept",
    defaultMessage: "Hyväksy"
  },
  save: {
    id: "common.save",
    defaultMessage: "Tallenna"
  },
  noSave: {
    id: "common.noSave",
    defaultMessage: "Poistu tallentamatta"
  },
  today: {
    id: "common.today",
    defaultMessage: "Tänään"
  },
  date: {
    id: "common.date",
    defaultMessage: "Päivämäärä"
  },
  datemax: {
    id: "common.datemax",
    defaultMessage: "Päiväys on liian suuri"
  },
  datemin: {
    id: "common.datemin",
    defaultMessage: "Päiväys on liian pieni"
  },
  dateinvalid: {
    id: "common.dateinvalid",
    defaultMessage: "Päiväys on virheellinen"
  },
  attachmentInfo: {
    id: "common.attachmentInfo",
    defaultMessage:
      "Liitteen koko saa olla korkeintaan 25 MB ja tyypiltään pdf, word, excel, jpeg tai gif. Muista merkitä salassa pidettävät liitteet."
  },
  attachmentNone: {
    id: "common.attachmentNone",
    defaultMessage: "Ei lisättyjä liitteitä"
  },
  attachmentError: {
    id: "common.attachmentError",
    defaultMessage:
      "Valitsemaasi liitettä ei voi lisätä hakemukseen, tarkista sen koko ja tyyppi"
  },
  attachmentAdd: {
    id: "common.attachmentAdd",
    defaultMessage: "Lisää liite"
  },
  attachmentAddPaatoskirje: {
    id: "common.attachmentAddPaatoskirje",
    defaultMessage: "Lisää päätöskirje"
  },
  attachmentAddJarjestamislupa: {
    id: "common.attachmentAddJarjestamislupa",
    defaultMessage: "Lisää järjestämislupa"
  },
  attachmentRemove: {
    id: "common.attachmentRemove",
    defaultMessage: "Poista liite"
  },
  attachmentSecret: {
    id: "common.attachmentSecret",
    defaultMessage: "Salainen liite"
  },
  attachmentSecretSelect: {
    id: "common.attachmentSecretSelect",
    defaultMessage: "Merkitse liite salaiseksi"
  },
  attachmentSecretUnselect: {
    id: "common.attachmentSecretUnselect",
    defaultMessage: "Merkitse liite julkiseksi"
  },
  attachmentName: {
    id: "common.attachmentName",
    defaultMessage: "Liitteen nimi *"
  },
  attachmentErrorName: {
    id: "common.attachmentErrorName",
    defaultMessage: "Nimi on pakollinen"
  },
  attachmentDownload: {
    id: "common.attachmentDownload",
    defaultMessage: "Lataa liite tietokoneelle"
  },
  loginError: {
    id: "common.loginError",
    defaultMessage: "Kirjautumisessa tapahtui virhe"
  },
  welcome: {
    id: "common.welcome",
    defaultMessage: "Tervetuloa Oiva-palveluun"
  },
  fetchFailure: {
    id: "common.fetchFailure",
    defaultMessage: "Tietoja ei voitu noutaa."
  },
  fetchFailureAuthInfo: {
    id: "common.fetchFailureAuthInfo",
    defaultMessage: "Tämä voi johtua siitä, ettet ole kirjautunut sisään."
  },
  application: {
    id: "common.application",
    defaultMessage: "Hakemus"
  },
  attachment: {
    id: "common.attachement",
    defaultMessage: "Liite"
  },
  secretAttachment: {
    id: "common.secretAttachement",
    defaultMessage: "Salainen liite"
  },
  asiat: {
    id: "common.asiat",
    defaultMessage: "Asiat"
  },
  asiatOpen: {
    id: "common.asiatOpen",
    defaultMessage: "Avoimet"
  },
  asiatReady: {
    id: "common.asiatReady",
    defaultMessage: "Päätetyt"
  },
  asiatKorjauksessa: {
    id: "common.asiatKorjauksessa",
    defaultMessage: "Korjauksessa"
  },
  document: {
    id: "common.document",
    defaultMessage: "Asiakirja"
  },
  author: {
    id: "common.author",
    defaultMessage: "Laatija"
  },
  documentStatus: {
    id: "common.documentStatus",
    defaultMessage: "Asiakirjan tila"
  },
  sent: {
    id: "common.sent",
    defaultMessage: "Lähetetty"
  },
  edit: {
    id: "common.edit",
    defaultMessage: "Täydennä hakemusta"
  },
  change: {
    id: "common.change",
    defaultMessage: "Järjestämisluvan muutos"
  },
  stateAsia: {
    id: "common.stateAsia",
    defaultMessage: "Asian tila"
  },
  functions: {
    id: "common.functions",
    defaultMessage: "Toiminnot"
  },
  hakemusAsiakirjat: {
    id: "common.hakemusAsiakirjat",
    defaultMessage: "Hakemuksen asiakirjat"
  },
  asianAsiakirjat: {
    id: "common.asianAsiakirjat",
    defaultMessage: "Järjestämisluvan muutos -asiakirjat"
  },
  asiakirjatTakaisin: {
    id: "common.asiakirjatTakaisin",
    defaultMessage: "Asiat-sivulle"
  },
  backFromAsiakirjat: {
    id: "common.backFromAsiakirjat",
    defaultMessage: "Takaisin Järjestämislupa asiat -taulukkoon"
  },
  newHakemus: {
    id: "common.newHakemus",
    defaultMessage: "Tee uusi hakemus"
  },
  tietoaTulevanJulkaisunAjankohdasta: {
    id: "common.tietoaTulevanJulkaisunAjankohdasta",
    defaultMessage: "Tulossa vuoden 2020 aikana"
  },
  siteShortDescription: {
    id: "common.siteShortDescription",
    defaultMessage: "Opetushallinnon ohjaus- ja säätelypalvelu"
  },
  sort: {
    id: "common.sort",
    defaultMessage: "Järjestä sarakkeen mukaan"
  },
  frontpage: {
    id: "common.frontpage",
    defaultMessage: "Etusivu"
  },
  since: {
    id: "common.since",
    defaultMessage: "{date} lukien"
  },
  jarjestaja: {
    id: "common.jarjestaja",
    defaultMessage: "Koulutuksen järjestäjä"
  },
  homeCounty: {
    id: "common.homeCounty",
    defaultMessage: "Kotipaikan maakunta"
  },
  kjAsiaTableDnro: {
    id: "common.kjAsiaTableDnro",
    defaultMessage: "OKM:n Dnro"
  },
  kjAsiaTableAsia: {
    id: "common.kjAsiaTableAsia",
    defaultMessage: "Asia"
  },
  kjAsiaTableState: {
    id: "common.kjAsiaTableState",
    defaultMessage: "Tila"
  },
  kjAsiaTableDueDate: {
    id: "common.kjAsiaTableDueDate",
    defaultMessage: "Määräaika"
  },
  kjAsiaTablePaatetty: {
    id: "common.kjAsiaTablePaatetty",
    defaultMessage: "Päätetty"
  },
  "asiaTable.headers.asianumero": {
    id: "asiaTable.headers.asianumero",
    defaultMessage: "Asianumero"
  },
  "asiaTable.headers.tila": {
    id: "asiaTable.headers.tila",
    defaultMessage: "Tila"
  },
  "asiaTable.headers.asia": {
    id: "asiaTable.headers.asia",
    defaultMessage: "Asia"
  },
  "asiaTable.headers.asiakas": {
    id: "asiaTable.headers.asiakas",
    defaultMessage: "Koulutuksen järjestäjä"
  },
  "asiaTable.headers.asiakas.ammatillinen-koulutus": {
    id: "asiaTable.headers.asiakas.ammatillinen-koulutus",
    defaultMessage: "Koulutuksen järjestäjä"
  },
  "asiaTable.headers.asiakas.esi-ja-perusopetus": {
    id: "asiaTable.headers.asiakas.esi-ja-perusopetus",
    defaultMessage: "Opetuksen järjestäjä"
  },
  "asiaTable.headers.asiakas.lukiokoulutus": {
    id: "asiaTable.headers.asiakas.lukiokoulutus",
    defaultMessage: "Koulutuksen järjestäjä"
  },
  "asiaTable.headers.asiakas.vapaa-sivistystyo": {
    id: "asiaTable.headers.vapaa-sivistystyo",
    defaultMessage: "Oppilaitoksen ylläpitäjä"
  },
  "asiaTable.headers.asiakas.taiteen-perusopetus": {
    id: "asiaTable.headers.taiteen-perusopetus",
    defaultMessage: "Opetuksen järjestäjä"
  },
  "asiaTable.headers.asiakas.tuva": {
    id: "asiaTable.headers.tuva",
    defaultMessage: "Koulutusmuoto"
  },
  "asiaTable.headers.maakunta": {
    id: "asiaTable.headers.maakunta",
    defaultMessage: "Maakunta"
  },
  "asiaTable.headers.oppilaitostyyppi": {
    id: "asiaTable.headers.oppilaitostyyppi",
    defaultMessage: "Oppilaitostyyppi"
  },
  "asiaTable.headers.saapunut": {
    id: "asiaTable.headers.saapunut",
    defaultMessage: "Saapunut/luotu"
  },
  "asiaTable.headers.paatospvm": {
    id: "asiaTable.headers.paatospvm",
    defaultMessage: "Päätöspäivämäärä"
  },
  "asiaTable.headers.hakupvm": {
    id: "asiaTable.headers.hakupvm",
    defaultMessage: "Haettu voimaantulo"
  },
  "asiaTable.headers.actions": {
    id: "asiaTable.headers.actions",
    defaultMessage: "Toiminnot"
  },
  "asiaTable.actions.handle": {
    id: "asiaTable.headers.actions",
    defaultMessage: "Toiminnot"
  },
  "asiaTable.actions.valmistelussa": {
    id: "asiaTable.actions.valmistelussa",
    defaultMessage: "Merkitse valmistelussa"
  },
  "asiaTable.actions.esittelyssa": {
    id: "asiaTable.actions.esittelyssa",
    defaultMessage: "Merkitse esittelyssä"
  },
  "asiaTable.actions.paatetty": {
    id: "asiaTable.actions.paatetty",
    defaultMessage: "Merkitse päätetyksi"
  },
  "asiaTable.actions.lataa": {
    id: "asiaTable.actions.lataa",
    defaultMessage: "Lataa PDF"
  },
  "asiaTable.actions.lataaLiite": {
    id: "asiaTable.actions.lataaLiite",
    defaultMessage: "Lataa liite"
  },
  "asiaTable.actions.lataaPDFJaMuutaTila": {
    id: "asiaTable.actions.lataaPDFJaMuutaTila",
    defaultMessage: "Lataa PDF ja muuta tila"
  },
  "asiaStates.kj.LUONNOS": {
    id: "asiaStates.kj.LUONNOS",
    defaultMessage: "Luonnos"
  },
  "asiaStates.kj.AVOIN": {
    id: "asiaStates.kj.AVOIN",
    defaultMessage: "Lähetetty"
  },
  "asiaStates.kj.VALMISTELUSSA": {
    id: "asiaStates.kj.VALMISTELUSSA",
    defaultMessage: "Lähetetty"
  },
  "asiaStates.kj.TAYDENNETTAVA": {
    id: "asiaStates.kj.TAYDENNETTAVA",
    defaultMessage: "Täydennettävä"
  },
  "asiaStates.kj.PAATETTY": {
    id: "asiaStates.kj.PAATETTY",
    defaultMessage: "Päätetty"
  },
  "asiaStates.kj.PASSIVOITU": {
    id: "asiaStates.kj.PASSIVOITU",
    defaultMessage: "Poistettu"
  },
  "asiaStates.esittelija.LUONNOS": {
    id: "asiaStates.esittelija.LUONNOS",
    defaultMessage: "Luonnos"
  },
  "asiaStates.esittelija.AVOIN": {
    id: "asiaStates.esittelija.AVOIN",
    defaultMessage: "Saapunut"
  },
  "asiaStates.esittelija.VALMISTELUSSA": {
    id: "asiaStates.esittelija.VALMISTELUSSA",
    defaultMessage: "Valmistelussa"
  },
  "asiaStates.esittelija.ESITTELYSSA": {
    id: "asiaStates.esittelija.ESITTELYSSA",
    defaultMessage: "Esittelyssä"
  },
  "asiaStates.esittelija.TAYDENNETTAVA": {
    id: "asiaStates.esittelija.TAYDENNETTAVA",
    defaultMessage: "Täydennettävä"
  },
  "asiaStates.esittelija.PAATETTY": {
    id: "asiaStates.esittelija.PAATETTY",
    defaultMessage: "Päätetty"
  },
  "asiaStates.esittelija.KORJAUKSESSA": {
    id: "asiaStates.esittelija.KORJAUKSESSA",
    defaultMessage: "Korjauksessa"
  },
  "asiaStates.esittelija.PASSIVOITU": {
    id: "asiaStates.esittelija.PASSIVOITU",
    defaultMessage: "Poistettu"
  },
  "asiaTypes.lupaChange": {
    id: "asiaTypes.lupaChange",
    defaultMessage: "Järjestämisluvan muutos"
  },
  current: {
    id: "common.current",
    defaultMessage: "Nykyinen"
  },
  toBeAdded: {
    id: "common.toBeAdded",
    defaultMessage: "Lisättävä"
  },
  toBeRemoved: {
    id: "common.toBeRemoved",
    defaultMessage: "Poistettava"
  },
  ammatillisenKoulutuksenJarjestajat: {
    id: "common.ammatillisenKoulutuksenJarjestajat",
    defaultMessage: "Ammatillisen koulutuksen järjestäjät"
  },
  voimassaOlevatJarjestamisluvat: {
    id: "common.voimassaOlevatJarjestamisluvat",
    defaultMessage: "Voimassa olevat järjestämisluvat ({amount} kpl)"
  },
  lupaLatest: {
    id: "common.lupaLatest",
    defaultMessage: "Viimeisin päätös"
  },
  lupaPaatokset: {
    id: "common.lupaPaatokset",
    defaultMessage: "Lupapäätökset"
  },
  lupaHistoria: {
    id: "common.lupaHistoria",
    defaultMessage: "Historiatiedot"
  },
  errorFetchingRow: {
    id: "common.errorFetchingRow",
    defaultMessage: "Virhe haettaessa valitun rivin tietoja."
  },
  errorOpeningPDF: {
    id: "common.errorOpeningPDF",
    defaultMessage: "PDF:n avaaminen ei onnistunut."
  },
  errorLoadingLupaHistory: {
    id: "common.errorLoadingLupaHistory",
    defaultMessage: "Lupahistoriaa ladattaessa tapahtui virhe."
  },
  errorLoadingLupa: {
    id: "common.errorLoadingLupa",
    defaultMessage: "Järjestämislupatietojen näyttäminen epäonnistui."
  },
  diaarinumero: {
    id: "common.diaarinumero",
    defaultMessage: "Diaarinumero"
  },
  lupaHistoriaDiaarinumeroHeading: {
    id: "common.lupaHistoriaDiaarinumeroHeading",
    defaultMessage: "Asia-/Diaarinumero"
  },
  lupaHistoriaPaatosDateHeading: {
    id: "common.lupaHistoriaPaatosDateHeading",
    defaultMessage: "Päätöspvm"
  },
  lupaHistoriaStartDateHeading: {
    id: "common.lupaHistoriaStartDateHeading",
    defaultMessage: "Voimaantulopvm"
  },
  lupaHistoriaEndDateHeading: {
    id: "common.lupaHistoriaEndDateHeading",
    defaultMessage: "Päättämispvm"
  },
  lupaHistoriaKumottuDateHeading: {
    id: "common.lupaHistoriaKumottuDateHeading",
    defaultMessage: "Kumottu"
  },
  lupaHistoriaPaatosDateMobile: {
    id: "common.lupaHistoriaPaatosDateMobile",
    defaultMessage: "Päätös tehty: {date}"
  },
  lupaHistoriaValidDateRangeMobile: {
    id: "common.lupaHistoriaValidDateRangeMobile",
    defaultMessage: "Voimassa: {date1} - {date2}"
  },
  lupaHistoriaKumottuDateMobile: {
    id: "common.lupaHistoriaKumottuDateMobile",
    defaultMessage: "Kumottu: {date}"
  },
  asiatTitle: {
    id: "common.asiatTitle",
    defaultMessage: "Järjestämislupa-asiat"
  },
  lupaPageTitleAmmatillinen: {
    id: "common.lupaPageTitleAmmatillinen",
    defaultMessage:
      "Ajantasainen ammatillisten tutkintojen ja koulutuksen järjestämislupa {date}"
  },
  kokeilulupaPageTitleAmmatillinen: {
    id: "common.kokeilulupaPageTitleAmmatillinen",
    defaultMessage:
      "Ajantasainen ammatillisen koulutuksen toiminnanohjauksen kokeilusta annetun lain mukainen ammatillisten tutkintojen ja koulutuksen järjestämislupa {date}"
  },
  lupaTitle: {
    id: "common.lupaTitle",
    defaultMessage: "Järjestämislupa"
  },
  lupaSectionTitleAllLupas: {
    id: "common.lupaSectionTitleAllLupas",
    defaultMessage:
      "Koulutuksen järjestäjällä on oikeus myöntää seuraavia tutkintoja ja antaa niihin tutkintokoulutusta:"
  },
  lupaSectionTitleSupplementary: {
    id: "common.lupaSectionTitleSupplementary",
    defaultMessage:
      "Koulutuksen järjestäjä voi järjestää myös em. tutkintoihin liittyvää ammatillisesta koulutuksesta annetun lain\n (531/2017) 8 §:n 1 kohdassa tarkoitettua ammatillista osaamista syventävää tai täydentävää koulutusta."
  },
  lupaSectionTutkinnotMainTitle: {
    id: "common.lupaSectionTutkinnotMainTitle",
    defaultMessage: "Tutkinnot ja koulutukset"
  },
  lupaSectionTutkinnotValmaTitle: {
    id: "common.lupaSectionTutkinnotValmaTitle",
    defaultMessage:
      "Koulutuksen järjestäjällä on oikeus järjestää seuraavaa valmentavaa koulutusta:"
  },
  lupaSectionTutkinnotTelmaTitle: {
    id: "common.lupaSectionTutkinnotTelmaTitle",
    defaultMessage:
      "Koulutuksen järjestäjällä on oikeus järjestää seuraavaa valmentavaa koulutusta:"
  },
  lupaSectionTutkinnotAmmatillinenTitle: {
    id: "common.lupaSectionTutkinnotAmmatillinenTitle",
    defaultMessage:
      "Koulutuksen järjestäjällä on oikeus järjestää seuraavaa ammatilliseen tehtävään valmistavaa koulutusta:"
  },
  lupaSectionOpetuskieliMainTitle: {
    id: "common.lupaSectionOpetuskieliMainTitle",
    defaultMessage: "Opetus- ja tutkintokieli"
  },
  lupaSectionOpetuskieliSingular: {
    id: "common.lupaSectionOpetuskieliSingular",
    defaultMessage:
      "Koulutuksen järjestäjän on annettava opetusta seuraavalla opetuskielellä:"
  },
  lupaSectionOpetuskieliPlural: {
    id: "common.lupaSectionOpetuskieliPlural",
    defaultMessage:
      "Koulutuksen järjestäjän on annettava opetusta seuraavilla opetuskielillä:"
  },
  lupaSectionTutkintokieliAdditionalLanguages: {
    id: "common.lupaSectionTutkintokieliAdditionalLanguages",
    defaultMessage: "Tutkintokieli on em. opetuskielten lisäksi"
  },
  lupaSectionTutkintokieliFollowingDegreesSingular: {
    id: "common.lupaSectionTutkintokieliFollowingDegreesSingular",
    defaultMessage: "seuraavassa tutkinnossa"
  },
  lupaSectionTutkintokieliFollowingDegreesPlural: {
    id: "common.lupaSectionTutkintokieliFollowingDegreesPlural",
    defaultMessage: "seuraavissa tutkinnoissa"
  },
  lupaSectionToimintaAlueMainTitle: {
    id: "common.lupaSectionToimintaAlueMainTitle",
    defaultMessage: "Toiminta-alue"
  },
  lupaSectionToimintaAlueNational: {
    id: "common.lupaSectionToimintaAlueNational",
    defaultMessage:
      "Tutkintoja ja koulutusta saa lisäksi järjestää Ahvenanmaan maakuntaa lukuun ottamatta myös muualla Suomessa."
  },
  lupaSectionToimintaAlueNationalAlternative: {
    id: "common.lupaSectionToimintaAlueNationalAlternative",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta Ahvenanmaan maakuntaa lukuun ottamatta koko Suomen osaamis- ja koulutustarpeeseen."
  },
  lupaSectionToimintaAlueMaakuntaPluralKuntaPlural: {
    id: "common.lupaSectionToimintaAlueMaakuntaPluralKuntaPlural",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavien maakuntien ja kuntien alueen osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaSingularKuntaPlural: {
    id: "common.lupaSectionToimintaAlueMaakuntaSingularKuntaPlural",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavan maakunnan ja seuraavien kuntien osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaNoneKuntaPlural: {
    id: "common.lupaSectionToimintaAlueMaakuntaNoneKuntaPlural",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavien kuntien osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaPluralKuntaSingular: {
    id: "common.lupaSectionToimintaAlueMaakuntaPluralKuntaSingular",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavien maakuntien ja seuraavan kunnan osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaSingularKuntaSingular: {
    id: "common.lupaSectionToimintaAlueMaakuntaSingularKuntaSingular",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavan maakunnan ja kunnan osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaNoneKuntaSingular: {
    id: "common.lupaSectionToimintaAlueMaakuntaNoneKuntaSingular",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavan kunnan osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaPluralKuntaNone: {
    id: "common.lupaSectionToimintaAlueMaakuntaPluralKuntaNone",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavien maakuntien osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueMaakuntaSingularKuntaNone: {
    id: "common.lupaSectionToimintaAlueMaakuntaSingularKuntaNone",
    defaultMessage:
      "Koulutuksen järjestäjällä on velvollisuus järjestää tutkintoja ja koulutusta ensisijaisesti seuraavan maakunnan osaamis- ja koulutustarpeeseen:"
  },
  lupaSectionToimintaAlueNone: {
    id: "common.lupaSectionToimintaAlueNone",
    defaultMessage:
      "Koulutuksen järjestäjällä ei ole alueellista velvoitetta järjestää tutkintoja ja koulutusta. Koulutuksen järjestäjä saa järjestää tutkintoja ja koulutusta koko Suomessa Ahvenanmaan maakuntaa lukuun ottamatta."
  },
  lupaSectionOpiskelijavuodetMainTitle: {
    id: "common.lupaSectionOpiskelijavuodetMainTitle",
    defaultMessage: "Opiskelijavuodet ja niitä koskevat rajoitukset"
  },
  lupaSectionOpiskelijavuodetMinimum: {
    id: "common.lupaSectionOpiskelijavuodetMinimum",
    defaultMessage:
      "Koulutuksen järjestäjän opiskelijavuosien vähimmäismäärä on {arvo}"
  },
  lupaSectionOpiskelijavuodetMaximumMain: {
    id: "common.lupaSectionOpiskelijavuodetMaximumMain",
    defaultMessage:
      "Niiden opiskelijoiden osalta, jotka eivät ole oppivelvollisuuslain (1214/2020) 16 §:n nojalla oikeutettuja maksuttomaan koulutukseen, rahoituksen perusteena oleva opiskelijavuosien enimmäismäärä on {arvo}."
  },
  lupaSectionOpiskelijavuodetMaximum: {
    id: "common.lupaSectionOpiskelijavuodetMaximum",
    defaultMessage: "{tyyppi} enintään {arvo} opiskelijavuotta."
  },
  lupaSectionOpiskelijavuodetMaximumErityinen: {
    id: "common.lupaSectionOpiskelijavuodetMaximumErityinen",
    defaultMessage:
      "Vaativan erityisen tuen tehtävään käytettävien opiskelijavuosien enimmäismäärä on {arvo}."
  },
  lupaSectionOpiskelijavuodetLimitationSingular: {
    id: "common.lupaSectionOpiskelijavuodetLimitationSingular",
    defaultMessage: "Opiskelijavuosien enimmäismäärää koskee seuraava rajoitus:"
  },
  lupaSectionMuutMainTitle: {
    id: "common.lupaSectionMuutMainTitle",
    defaultMessage: "Muut oikeudet, velvollisuudet, ehdot ja tehtävät"
  },
  lupaSectionMuutEiMaarayksia: {
    id: "common.lupaSectionMuutEiMaarayksia",
    defaultMessage:
      "Koulutuksen järjestäjälle ei tässä järjestämisluvassa määrätä muita oikeuksia, velvollisuuksia, ehtoja tai tehtäviä."
  },
  noMaxYears: {
    id: "common.noMaxYears",
    defaultMessage:
      "Koulutuksen järjestäjälle ei määritetä opiskelijavuosien enimmäismäärää."
  },
  lupaSectionNoInfo: {
    id: "common.lupaSectionNoInfo",
    defaultMessage: "Ei kohdetietoja"
  },
  tutkinnot: {
    id: "common.tutkinnot",
    defaultMessage: "Tutkinnot"
  },
  koulutukset: {
    id: "common.koulutukset",
    defaultMessage: "Koulutukset"
  },
  luoUusiAsia: {
    id: "common.luoUusiAsia",
    defaultMessage: "Luo uusi asia"
  },
  luoUusiAsiaInstructions: {
    id: "common.luoUusiAsiaInstructions",
    defaultMessage:
      "Valitse sopiva koulutuksen järjestäjä listalta. Valinnan hyväksymisen jälkeen siirrytään automaattisesti luvan muokkaussivulle"
  },
  luoUusiAsiaInstructionsPO: {
    id: "common.luoUusiAsiaInstructionsPO",
    defaultMessage:
      "Valitse sopiva opetuksen järjestäjä listalta. Valinnan hyväksymisen jälkeen siirrytään automaattisesti luvan muokkaussivulle"
  },
  luoUusiAsiaInstructionsLukio: {
    id: "common.luoUusiAsiaInstructionsLukio",
    defaultMessage:
      "Valitse sopiva koulutuksen järjestäjä listalta. Valinnan hyväksymisen jälkeen siirrytään automaattisesti luvan muokkaussivulle"
  },
  luoUusiAsiaInstructionsVST: {
    id: "common.luoUusiAsiaInstructionsVST",
    defaultMessage:
      "Valitse sopiva koulutuksen ylläpitäjä listalta. Valinnan hyväksymisen jälkeen siirrytään automaattisesti luvan muokkaussivulle"
  },
  luoUusiAsiaInstructionsTPO: {
    id: "common.luoUusiAsiaInstructionsTPO",
    defaultMessage:
      "Valitse sopiva koulutuksen järjestäjä listalta. Valinnan hyväksymisen jälkeen siirrytään automaattisesti luvan muokkaussivulle"
  },
  luoUusiAsiaInstructions1TUVA: {
    id: "common.luoUusiAsiaInstructions1TUVA",
    defaultMessage:
      "Valitse ensin koulutusmuoto. Tämän jälkeen valitse se koulutuksen järjestäjä, jonka järjestämislupaa uusi TUVA-lupa koskee."
  },
  luoUusiAsiaInstructionsTUVA: {
    id: "common.luoUusiAsiaInstructionsTUVA",
    defaultMessage:
      "Valitse sopiva koulutuksen järjestäjä listalta. Valinnan hyväksymisen jälkeen siirrytään automaattisesti luvan muokkaussivulle"
  },
  muokkaa: {
    id: "common.muokkaa",
    defaultMessage: "Muokkaa"
  },
  poista: {
    id: "common.poista",
    defaultMessage: "Poista"
  },
  titleOfPoistetaankoKokoAsia: {
    id: "common.titleOfPoistetaankoKokoAsia",
    defaultMessage: "Tämän asiakirjan poisto poistaa koko asian"
  },
  poistetaankoKokoAsia: {
    id: "common.poistetaankoKokoAsia",
    defaultMessage:
      "Haluatko varmasti poistaa asiakirjan ja asian? Poiston jälkeen siirrytään Asiat-sivulle, jossa kyseinen asia ei ole enää näkyvillä."
  },
  titleOfPoistetaankoAsiakirja: {
    id: "common.titleOfPoistetaankoAsiakirja",
    defaultMessage: "Asiakirjan poisto"
  },
  poistetaankoAsiakirja: {
    id: "common.poistetaankoAsiakirja",
    defaultMessage:
      "Haluatko varmasti poistaa asiakirjan? Poiston jälkeen et voi enää muokata tätä asiakirjaa."
  },
  doNotRemove: {
    id: "common.doNotRemove",
    defaultMessage: "Älä poista"
  },
  titleOfPDFAndStateDialog: {
    id: "common.titleOfPDFAndStateDialog",
    defaultMessage: "Muutetaanko asian tila latauksen yhteydessä?"
  },
  textOfPDFAndStateDialog: {
    id: "common.textOfPDFAndStateDialog",
    defaultMessage:
      'Mikäli järjestämislupaa ollaan viemässä allekirjoitettavaksi, asian tila tulee muuttaa "Esittelyssä" tilaan. Muutetaanko tila?'
  },
  downloadPDFAndChangeState: {
    id: "common.downloadPDFAndChangeState",
    defaultMessage: "Lataa PDF ja muuta tila"
  },
  asiaPaatettyConfirmationDialogTitle: {
    id: "common.asiaPaatettyConfirmationDialogTitle",
    defaultMessage: "Merkitäänkö asia päätetyksi?"
  },
  asiaPaatettyConfirmationDialogContent: {
    id: "common.asiaPaatettyConfirmationDialogContent",
    defaultMessage:
      "Haluatko varmasti merkitä asian päätetyksi? Päätetyksi merkitsemisen jälkeen asiaa ei voi enää muokata."
  },
  asiaPaatettyConfirmationDialogOk: {
    id: "common.asiaPaatettyConfirmationDialogOk",
    defaultMessage: "Merkitse päätetyksi"
  },
  korjaaLupaaConfirmationDialogTitle: {
    id: "common.korjaaLupaaConfirmationDialogTitle",
    defaultMessage: "Haluatko korjata päätettyä lupaa?"
  },
  korjaaLupaaConfirmationDialogContent: {
    id: "common.korjaaLupaaConfirmationDialogContent",
    defaultMessage:
      "Luvan korjaustilassa voi korjata luvasta mahdollisia virheitä ja korvata asiaan liittyviä liitetiedostoja."
  },
  korjaaLupaaConfirmationDialogOk: {
    id: "common.korjaaLupaaConfirmationDialogOk",
    defaultMessage: "Siirry luvan korjaustilaan"
  },
  confirmExitMuutoshakemusWizard: {
    id: "common.confirmExitMuutoshakemus",
    defaultMessage:
      "Oletko varma, että haluat poistua muutoshakemuksen luonnista? Tekemiäsi muutoksia ei tallenneta."
  },
  confirmExitMuutoshakemusWizardTitle: {
    id: "common.confirmExitMuutoshakemusWizardTitle",
    defaultMessage: "Poistutaanko?"
  },
  confirmSendMuutoshakemus: {
    id: "common.confirmSendMuutoshakemus",
    defaultMessage:
      "Oletko varma, että haluat lähettää hakemuksen käsiteltäväksi?"
  },
  confirmSendMuutoshakemusTitle: {
    id: "common.confirmSendMuutoshakemusTitle",
    defaultMessage: "Lähetyksen varmistus"
  },
  confirmExitEsittelijaMuutoshakemusWizard: {
    id: "common.confirmExitEsittelijaMuutoshakemusWizard",
    defaultMessage:
      "Haluatko tallentaa järjestämislupaan tekemäsi muutokset? Voit myöhemmin palata tekemiisi muutoksiin tallennettuasi muutokset."
  },
  confirmExitEsittelijaMuutoshakemusWizardTitle: {
    id: "common.confirmExitEsittelijaMuutoshakemusWizardTitle",
    defaultMessage: "Tallennetaanko muutokset ennen poistumista?"
  },
  yhteydenotto: {
    id: "common.yhteydenotto",
    defaultMessage: "Yhteydenotto"
  },
  saavutettavuusseloste: {
    id: "common.saavutettavuusseloste",
    defaultMessage: "Saavutettavuusseloste"
  },
  valtioneuvosto: {
    id: "common.valtioneuvosto",
    defaultMessage: "Valtioneuvosto"
  },
  phoneNumber: {
    id: "common.phoneNumber",
    defaultMessage: "Puh. 029 533 0004"
  },
  okmAddress: {
    id: "common.okmAddress",
    defaultMessage: "PL 29, 00023 Valtioneuvosto"
  },
  okmLinkText: {
    id: "common.okmLinkText",
    defaultMessage: "www.minedu.fi"
  },
  okmLinkUrl: {
    id: "common.okmLinkUrl",
    defaultMessage: "http://www.minedu.fi"
  },
  decisionDetails: {
    id: "common.decisionDetails",
    defaultMessage: "Päätöksen tiedot"
  },
  ytunnus: {
    id: "common.ytunnus",
    defaultMessage: "Y-tunnus"
  },
  viiva: {
    id: "common.viiva",
    defaultMessage: "Viiva"
  },
  breadCrumbs: {
    id: "common.breadCrumbs",
    defaultMessage: "Murupolku"
  },
  jumpToContent: {
    id: "common.jumpToContent",
    defaultMessage: "Hyppää sisältöön"
  },
  paatoskirje: {
    id: "common.paatoskirje",
    defaultMessage: "Päätöskirje"
  },
  rowsPerPage: {
    id: "common.rowsPerPage",
    defaultMessage: "Rivejä per sivu:"
  },
  rows: {
    id: "common.rows",
    defaultMessage: "Rivit:"
  },
  lupapaatoksetTaulukko: {
    id: "common.lupapaatoksetTaulukko",
    defaultMessage: "Lupapäätökset-taulukko"
  },
  jarjestajaluettelo: {
    id: "common.jarjestajaluettelo",
    defaultMessage: "Luettelo koulutuksen järjestäjistä"
  },
  www: {
    id: "common.www",
    defaultMessage: "WWW"
  },
  filterRows: {
    id: "common.filterRows",
    defaultMessage: "Suodata rivejä..."
  },
  navigationBetweenTablePages: {
    id: "common.navigationBetweenTablePages",
    defaultMessage: "Navigointi taulukon sivujen välillä"
  },
  siirryTaulukonEnsimmaiselleSivulleOhje: {
    id: "common.siirryTaulukonEnsimmaiselleSivulleOhje",
    defaultMessage:
      "Olet taulukon sivulla {pageIndex}. Siirry taulukon ensimmäiselle sivulle."
  },
  siirryTaulukonEdelliselleSivulleOhje: {
    id: "common.siirryTaulukonEdelliselleSivulleOhje",
    defaultMessage:
      "Olet taulukon sivulla {pageIndex}. Siirry edelliselle sivulle."
  },
  siirryTaulukonSeuraavalleSivulleOhje: {
    id: "common.siirryTaulukonSeuraavalleSivulleOhje",
    defaultMessage:
      "Olet taulukon sivulla {pageIndex}. Siirry seuraavalle sivulle."
  },
  siirryTaulukonViimeiselleSivulleOhje: {
    id: "common.siirryTaulukonViimeiselleSivulleOhje",
    defaultMessage:
      "Olet taulukon sivulla {pageIndex}. Siirry taulukon viimeiselle sivulle."
  },
  ensimmainenSivu: {
    id: "common.ensimmainenSivu",
    defaultMessage: "Ensimmäinen sivu"
  },
  edellinen: {
    id: "common.edellinen",
    defaultMessage: "Edellinen"
  },
  seuraava: {
    id: "common.seuraava",
    defaultMessage: "Seuraava"
  },
  viimeinenSivu: {
    id: "common.viimeinenSivu",
    defaultMessage: "Viimeinen sivu"
  },
  siirrySivulle: {
    id: "common.siirrySivulle",
    defaultMessage: "Siirry sivulle"
  },
  siirryKJnTarkempiinTietoihin: {
    id: "common.siirryKJnTarkempiinTietoihin",
    defaultMessage:
      "Siirry koulutuksen järjestäjän {nimi} tarkempiin tietoihin."
  },
  kjSivuinfo: {
    id: "common.kjSivuinfo",
    defaultMessage:
      "Tämä sivu sisältää taulukon voimassa olevista järjestämisluvista, joita on {kpl} kappaletta. Kukin lupa kuuluu jollekin koulutuksen järjestäjälle, jonka nimen kautta pääset tarkastelemaan tarkempia tietoja. Voit liikkua taulukon sivujen välillä käyttämällä taulukon alapuolella olevaa sivutustoiminnallisuutta."
  },
  kokeilulupaInfo: {
    id: "common.kokeilulupaInfo",
    defaultMessage:
      "*Toiminnanohjauksen kokeilusta annetun lain mukainen järjestämislupa"
  },
  tilastosivunOhje: {
    id: "common.tilastosivunOhje",
    defaultMessage: "Linkkejä tilastodataan (beta-versio):"
  },
  ammatillisenKoulutuksenJarjestamisluvat: {
    id: "common.ammatillisenKoulutuksenJarjestamisluvat",
    defaultMessage: "Ammatillisen koulutuksen järjestämisluvat"
  },
  perusopetuksenJarjestamisluvat: {
    id: "common.perusopetuksenJarjestamisluvat",
    defaultMessage: "Perusopetuksen järjestämisluvat"
  },
  vapaanSivistystyonJarjestamisluvat: {
    id: "common.vapaanSivistystyonJarjestamisluvat",
    defaultMessage: "Vapaan sivistystyön järjestämisluvat"
  },
  tuvaKoulutuksenJarjestamisluvat: {
    id: "common.tuvaKoulutuksenJarjestamisluvat",
    defaultMessage: "TUVA-koulutuksen järjestämisluvat"
  },
  lukioKoulutuksenJarjestamisluvat: {
    id: "common.lukioKoulutuksenJarjestamisluvat",
    defaultMessage: "Lukiokoulutuksen järjestämisluvat"
  },
  haeKJYtunnuksella: {
    id: "common.haeKJYtunnuksella",
    defaultMessage: "Hae koulutuksen järjestäjää Y-tunnuksella"
  },
  haeKJ: {
    id: "common.haeKJ",
    defaultMessage: "Hae koulutuksen järjestäjää (Y-tunnus, OID, Virastotunnus)"
  },
  haeKJPO: {
    id: "common.haeKJPO",
    defaultMessage: "Hae opetuksen järjestäjää (Y-tunnus, OID, Virastotunnus)"
  },
  haeKJLukio: {
    id: "common.haeKJLukio",
    defaultMessage: "Hae koulutuksen järjestäjää (Y-tunnus, OID, Virastotunnus)"
  },
  haeKJVST: {
    id: "common.haeKJVST",
    defaultMessage: "Hae opetuksen ylläpitäjää (Y-tunnus, OID, Virastotunnus)"
  },
  haeKJTPO: {
    id: "common.haeKJTPO",
    defaultMessage: "Hae koulutuksen järjestäjää (Y-tunnus, OID, Virastotunnus)"
  },
  haeKJTUVA: {
    id: "common.haeKJTUVA",
    defaultMessage: "Hae koulutuksen järjestäjää (Y-tunnus, OID, Virastotunnus)"
  },
  luoUusiAsiaEsidialogiInfo2: {
    id: "common.luoUusiAsiaEsidialogiInfo2",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea koulutuksen järjestäjää Y-tunnuksella."
  },
  luoUusiAsiaEsidialogiInfo3: {
    id: "common.luoUusiAsiaEsidialogiInfo3",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea koulutuksen järjestäjää hakutoiminnolla."
  },
  luoUusiAsiaEsidialogiInfo3PO: {
    id: "common.luoUusiAsiaEsidialogiInfo3PO",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea opetuksen järjestäjää hakutoiminnolla."
  },
  luoUusiAsiaEsidialogiInfo3Lukio: {
    id: "common.luoUusiAsiaEsidialogiInfo3Lukio",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea koulutuksen järjestäjää hakutoiminnolla."
  },
  luoUusiAsiaEsidialogiInfo3VST: {
    id: "common.luoUusiAsiaEsidialogiInfo3VST",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea oppilaitoksen ylläpitäjää hakutoiminnolla."
  },
  luoUusiAsiaEsidialogiInfo3TPO: {
    id: "common.luoUusiAsiaEsidialogiInfo3TPO",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea koulutuksen järjestäjää hakutoiminnolla."
  },
  luoUusiAsiaEsidialogiInfo3TUVA: {
    id: "common.luoUusiAsiaEsidialogiInfo3TUVA",
    defaultMessage:
      "Mikäli et löydä sopivaa valintaa listalta, voit hakea koulutuksen järjestäjää hakutoiminnolla."
  },
  suoritaYtunnushaku: {
    id: "common.suoritaYtunnushaku",
    defaultMessage: "Hae"
  },
  haullaLoytyiKJ: {
    id: "common.haullaLoytyiKJ",
    defaultMessage: "Haulla löytyi koulutuksenjärjestäjä"
  },
  haullaLoytyiKJPO: {
    id: "common.haullaLoytyiKJPO",
    defaultMessage: "Haulla löytyi opetuksen järjestäjä"
  },
  haullaLoytyiKJLukio: {
    id: "common.haullaLoytyiKJLukio",
    defaultMessage: "Haulla löytyi koulutuksen järjestäjä"
  },
  haullaLoytyiKJVST: {
    id: "common.haullaLoytyiKJVST",
    defaultMessage: "Haulla löytyi opetuksen ylläpitäjä"
  },
  haullaLoytyiKJTPO: {
    id: "common.haullaLoytyiKJTPO",
    defaultMessage: "Haulla löytyi koulutuksen järjestäjä"
  },
  haullaLoytyiKJTUVA: {
    id: "common.haullaLoytyiKJTUVA",
    defaultMessage: "Haulla löytyi koulutuksen järjestäjä"
  },
  KJHakuEpaonnistui: {
    id: "common.KJHakuEpaonnistui",
    defaultMessage: "Haulla ei löytynyt yhtään koulutuksenjärjestäjää"
  },
  KJHakuEpaonnistuiLisainfo: {
    id: "common.KJHakuEpaonnistuiLisainfo",
    defaultMessage:
      "Tarkista syöttämäsi Y-tunnus. Mikäli koulutuksen järjestäjää ei löydy, ota yhteyttä Opetushallituksen organisaatiopalveluun"
  },
  yhteisetpalvelutEmailAddress: {
    id: "common.yhteisetPalvelutEmailAddress",
    defaultMessage: "yhteisetpalvelut@opintopolku.fi"
  },
  syotaYtunnus: {
    id: "common.syotaYtunnus",
    defaultMessage: "Syötä Y-tunnus"
  },
  syotaHaettavaTunniste: {
    id: "common.syotaHaettavaTunniste",
    defaultMessage: "Syötä haettava tunniste"
  },
  suljeHaku: {
    id: "common.suljeHaku",
    defaultMessage: "Sulje haku"
  },
  loytyyjoVoimassaOlevaLupa: {
    id: "common.loytyyjoVoimassaOlevaLupa",
    defaultMessage:
      "Tällä koulutuksen järjestäjällä on jo voimassa oleva järjestämislupa. Hyväksymällä siirrytään luvan muokkaussivulle."
  },
  lupaOnKorjauksessa: {
    id: "common.lupaOnKorjauksessa",
    defaultMessage:
      "Koulutuksenjärjestäjän viimeisin lupa on korjauksessa. Ei voida luoda uutta asiaa."
  },
  avoinMuutosasia: {
    id: "common.avoinMuutosasia",
    defaultMessage:
      "Lupaa ei voida korjata, koska koulutuksenjärjestäjälle on jo avoin muutosasia."
  },
  oneKJMustBeSelected: {
    id: "common.oneKJMustBeSelected",
    defaultMessage:
      "Sinun tulee valita yksi koulutuksen järjestäjä, ennen kuin voit jatkaa eteenpäin"
  },
  oneKoulutusmuotoMustBeSelected: {
    id: "common.oneKoulutusmuotoMustBeSelected",
    defaultMessage: "Ole hyvä ja valitse ensin koulutusmuoto."
  },
  oneLanguageMustBeSelected: {
    id: "common.oneLanguageMustBeSelected",
    defaultMessage:
      "Sinun tulee valita yksi luvan kielistä, ennen kuin voit jatkaa eteenpäin"
  },
  existingMuutospyynto: {
    id: "common.existingMuutospyynto",
    defaultMessage:
      "Tällä koulutuksen järjestäjällä on avoinna oleva muutospyyntö. Poista tai päätä aiempi muutospyyntö ennen uuden luomista."
  },
  tilaValmis: {
    id: "common.tilaValmis",
    defaultMessage: "Valmis"
  },
  opetusJaKulttuuriministerio: {
    id: "common.opetusJaKulttuuriministerio",
    defaultMessage: "Opetus- ja kulttuuriministeriö"
  },
  minimumAmountOfYears: {
    id: "common.minimumAmountOfYears",
    defaultMessage: "Nykyinen"
  },
  maximumAmountOfYears: {
    id: "common.maximumAmountOfYears",
    defaultMessage: "Nykyinen"
  },
  asianhallinta: {
    id: "common.asianhallinta",
    defaultMessage: "Asianhallinta"
  },
  asianhallintaInfoText: {
    id: "common.asianhallintaInfoText",
    defaultMessage:
      "Valitse alla olevista vaihtoehdoista se koulutusmuoto, jonka järjestämislupia haluat käsitellä."
  },
  KJPassiivinen: {
    id: "common.KJPassiivinen",
    defaultMessage:
      "Tämä koulutuksen järjestäjä on passivoitu Opetushallituksen organisaatiopalvelussa. Ota yhteyttä"
  },
  page: {
    id: "common.page",
    defaultMessage: "Sivu"
  },
  aloituspaivamaara: {
    id: "common.aloituspaivamaara",
    defaultMessage: "Aloituspäivämäärä"
  },
  paattymispaivamaara: {
    id: "common.paattymispaivamaara",
    defaultMessage: "Päättymispäivämäärä"
  },
  lisatiedotInfo: {
    id: "common.lisatiedotInfo",
    defaultMessage:
      "Voit kirjoittaa tähän osioon liittyviä lisätietoja alla olevaan kenttään. Lisätiedot näkyvät luvassa tämän osion valintojen yhteydessä."
  },
  lisatiedot: {
    id: "common.lisatiedot",
    defaultMessage: "Lisätiedot"
  },
  vahintaan: {
    id: "common.vahintaan",
    defaultMessage: "Vähintään"
  },
  enintaan: {
    id: "common.enintaan",
    defaultMessage: "Enintään"
  },
  valitseYksiTaiUseampi: {
    id: "common.valitseYksiTaiUseampi",
    defaultMessage: "Valitse yksi tai useampi"
  },
  opetuskieli: {
    id: "common.opetuskieli",
    defaultMessage: "Opetuskieli"
  },
  maaJaPaikkakunta: {
    id: "common.maaJaPaikkakunta",
    defaultMessage: "Maa ja paikkakunta"
  },
  nimi: {
    id: "common.nimi",
    defaultMessage: "Nimi"
  },
  lisaaMaarays: {
    id: "common.lisaaMaarays",
    defaultMessage: "Lisää määräys"
  },
  lisaaUusiNimi: {
    id: "common.lisaaUusiNimi",
    defaultMessage: "Lisää uusi nimi"
  },
  kielet: {
    id: "common.kielet",
    defaultMessage: "kielet"
  },
  lisaaUusiKuvaus: {
    id: "common.lisaaUusiKuvaus",
    defaultMessage: "Lisää uusi kuvaus"
  },
  kuvaus: {
    id: "common.kuvaus",
    defaultMessage: "Kuvaus"
  },
  kuvausPlaceholder: {
    id: "common.kuvausPlaceholder",
    defaultMessage: "Kirjoita kuvaus tähän"
  },
  VSTOppilaitosTitle: {
    id: "common.VSTOppilaitosTitle",
    defaultMessage: "Oppilaitos"
  },
  yllapitaja: {
    id: "common.yllapitaja",
    defaultMessage: "Oppilaitoksen ylläpitäjä"
  },
  oppilaitostyyppi: {
    id: "common.oppilaitostyyppi",
    defaultMessage: "Oppilaitostyyppi"
  },
  filterByOppilaitostyyppi: {
    id: "common.filterByOppilaitostyyppi",
    defaultMessage: "Rajaa oppilaitostyypin mukaan"
  },
  filterByKoulutusmuoto: {
    id: "common.filterByKoulutusmuoto",
    defaultMessage: "Rajaa koulutusmuodon mukaan"
  },
  vstYllapitajatHeading: {
    id: "common.vstYllapitajatHeading",
    defaultMessage: "Vapaan sivistystyön oppilaitosten ylläpitäjät"
  },
  vstActiveLuvatCount: {
    id: "common.vstActiveLuvatCount",
    defaultMessage: "Voimassa olevat ylläpitämisluvat ({count} kpl)"
  },
  searchByYllapitaja: {
    id: "common.searchByYllapitaja",
    defaultMessage: "Hae ylläpitäjän tai oppilaitoksen nimellä"
  },
  noSelection: {
    id: "common.noSelection",
    defaultMessage: "Ei valintaa"
  },
  displayingPortion: {
    id: "common.displayingPortion",
    defaultMessage: "Näytetään {selectedCount}/{allCount}"
  },
  vstTitleName: {
    id: "common.vstTitleName",
    defaultMessage: "Vapaa sivistystyö"
  },
  yllapitamisLupaTitle: {
    id: "common.yllapitamisLupaTitle",
    defaultMessage: "Ylläpitämislupa"
  },
  VSTLupaSectionTitleOrganizer: {
    id: "common.VSTLupaSectionTitleOrganizer",
    defaultMessage: "Ylläpitäjän nimi ja kotipaikka"
  },
  VSTLupaSectionTitleMunicipality: {
    id: "common.VSTLupaSectionTitleMunicipality",
    defaultMessage: "Sopimuskunnat"
  },
  VSTLupaSectionTitleSchoolNameAndLocation: {
    id: "common.VSTLupaSectionTitleSchoolNameAndLocation",
    defaultMessage: "Oppilaitoksen nimi ja sijainti"
  },
  VSTLupaSectionTitleOperationalArea: {
    id: "common.VSTLupaSectionTitleOperationalArea",
    defaultMessage: "Oppilaitoksen toiminta-alue"
  },
  VSTLupaSectionTitleTeachingLanguage: {
    id: "common.VSTLupaSectionTitleTeachingLanguage",
    defaultMessage: "Opetuskieli"
  },
  VSTLupaSectionTitleSchoolPurpose: {
    id: "common.VSTLupaSectionTitleSchoolPurpose",
    defaultMessage: "Oppilaitoksen tarkoitus"
  },
  VSTLupaSectionTitleSchoolMission: {
    id: "common.VSTLupaSectionTitleSchoolMission",
    defaultMessage: "Oppilaitoksen koulutustehtävä"
  },
  VSTLupaSectionTitleSchoolMissionSpecial: {
    id: "common.VSTLupaSectionTitleSchoolMissionSpecial",
    defaultMessage: "Erityinen koulutustehtävä"
  },
  VSTLupaSectionTitleOther: {
    id: "common.VSTLupaSectionTitleOther",
    defaultMessage: "Muut koulutuksen järjestämiseen liittyvät ehdot"
  },
  lupaPageTitleLukio: {
    id: "common.lupaPageTitleLukio",
    defaultMessage: "Ajantasainen lukiokoulutuksen järjestämislupa {date}"
  },
  lupaPageTitleVSTKansalaisopisto: {
    id: "common.lupaPageTitleVSTKansalaisopisto",
    defaultMessage: "Ajantasainen kansalaisopiston ylläpitämislupa {date}"
  },
  lupaPageTitleVSTMuut: {
    id: "common.lupaPageTitleVSTMuut",
    defaultMessage: "Ajantasainen Snellman-korkeakoulun ylläpitämislupa {date}"
  },
  lupaPageTitleVSTOpintokeskus: {
    id: "common.lupaPageTitleVSTOpintokeskus",
    defaultMessage: "Ajantasainen opintokeskuksen ylläpitämislupa {date}"
  },
  lupaPageTitleVSTKansanopisto: {
    id: "common.lupaPageTitleVSTKansanopisto",
    defaultMessage: "Ajantasainen kansanopiston ylläpitämislupa {date}"
  },
  lupaPageTitleVSTKesayliopisto: {
    id: "common.lupaPageTitleVSTKesäyliopisto",
    defaultMessage: "Ajantasainen kesäyliopiston ylläpitämislupa {date}"
  },
  lupaPageTitleVSTLiikunnanKoulutuskeskus: {
    id: "common.lupaPageTitleVSTLiikunnanKoulutuskeskus",
    defaultMessage:
      "Ajantasainen liikunnan koulutuskeskuksen ylläpitämislupa {date}"
  },
  voimassaoleva: {
    id: "common.voimassaoleva",
    defaultMessage: "Voimassaoleva"
  },
  lupaSisaltaaYhteistyosopimuksia: {
    id: "common.lupaSisaltaaYhteistyosopimuksia",
    defaultMessage: "Lupa sisältää yhteistyösopimuksia"
  },
  maarayksenKuvaus: {
    id: "common.maarayksenKuvaus",
    defaultMessage: "Määräyksen kuvaus"
  },
  maarayksenXKuvaus: {
    id: "common.maarayksenXKuvaus",
    defaultMessage: "Määräyksen {nro} kuvaus"
  },
  lisaaUusiYhteistyosopimus: {
    id: "common.lisaaUusiYhteistyosopimus",
    defaultMessage: "Lisää uusi yhteistyösopimus"
  },
  htmlLuvanOtsikko: {
    id: "common.htmlLuvanOtsikko",
    defaultMessage: "Ajantasainen {koulutusmuodon} järjestämislupa {date}"
  },
  yllapitamislupaDownload: {
    id: "common.yllapitamislupaDownload",
    defaultMessage: "Lataa ylläpitämislupa"
  },
  jarjestamislupaDownload: {
    id: "common.jarjestamislupaDownload",
    defaultMessage: "Lataa järjestämislupa"
  },
  paatoskirjeDownload: {
    id: "common.paatoskirjeDownload",
    defaultMessage: "Lataa päätöskirje"
  },
  jarjestamisJaYllapitamisluvat: {
    id: "common.jarjestamisJaYllapitamisluvat",
    defaultMessage: "Järjestämis- ja ylläpitämisluvat"
  },
  jarjestamisJaYllapitamisluvatOtsikko: {
    id: "common.jarjestamisJaYllapitamisluvatOtsikko",
    defaultMessage: "Järjestämis- ja ylläpitämisluvat"
  },
  esikatselu: {
    id: "common.esikatselu",
    defaultMessage: "Esikatselu"
  },
  opetusJotaLupaKoskee: {
    id: "common.opetusJotaLupaKoskee",
    defaultMessage: "Opetus, jota lupa koskee"
  },
  is: {
    id: "common.is",
    defaultMessage: "on"
  },
  henkiloa: {
    id: "common.henkiloa",
    defaultMessage: "henkiloa"
  },
  kunnassa: {
    id: "common.kunnassa",
    defaultMessage: "kunnassa"
  },
  autocompleteValitse: {
    id: "common.autocompleteValitse",
    defaultMessage: "Valitse..."
  },
  asianumero: {
    id: "common.asianumero",
    defaultMessage: "asianumero"
  },
  paatospaiva: {
    id: "common.paatospaiva",
    defaultMessage: "Päätöspäivä"
  },
  paattymispaiva: {
    id: "common.paattymispaiva",
    defaultMessage: "Päättymispäivä"
  },
  voimaantulopaiva: {
    id: "common.voimaantulopaiva",
    defaultMessage: "Voimaantulopäivä"
  },
  kokeilulupa: {
    id: "common.kokeilulupa",
    defineMessages: "Kokeilulupa"
  },
  eiValittaviaKohteita: {
    id: "common.eiValittaviaKohteita",
    defaultMessage: "Ei valittavia kohteita"
  },
  eiAvoimiaAsioita: {
    id: "common.eiAvoimiaAsioita",
    defaultMessage: "Taulukossa ei ole yhtään avoinna olevaa asiaa"
  },
  eiKorjattaviaAsioita: {
    id: "common.eiKorjattaviaAsioita",
    defaultMessage: "Taulukossa ei ole yhtään korjauksessa olevaa asiaa"
  },
  sulje: {
    id: "common.sulje",
    defaultMessage: "Sulje"
  },
  onVoimassa: {
    id: "common.onVoimassa",
    defaultMessage: "Järjestämislupa on voimassa {loppupvm} asti"
  },
  mainNavigation: {
    id: "common.mainNavigation",
    defaultMessage: "Päänavigaatio"
  },
  valitseLuvanKieli: {
    id: "common.valitseLuvanKieli",
    defaultMessage: "Valitse luvan kieli"
  },
  valitseKoulutusmuoto: {
    id: "common.valitseKoulutusmuoto",
    defaultMessage: "Valitse koulutusmuoto"
  },
  valitseOrganisaatio: {
    id: "common.valitseOrganisaatio",
    defaultMessage: "Valitse organisaatio (järjestäjä)"
  },
  palautaValmisteluun: {
    id: "common.palautaValmisteluun",
    defaultMessage: "Palauta valmisteluun"
  },
  vieEsittelyyn: {
    id: "common.vieEsittelyyn",
    defaultMessage: "Vie esittelyyn"
  },
  korjaaLupaa: {
    id: "common.korjaaLupaa",
    defaultMessage: "Korjaa lupaa"
  },
  asiaKauttaDiaarinumero: {
    id: "common.asiaKauttaDiaarinumero",
    defaultMessage: "Asia-/Diaarinumero"
  },
  haeTaulukosta: {
    id: "common.haeTaulukosta",
    defaultMessage: "Hae taulukosta"
  },
  VSTOpetuksenYllapitajallaEiLupaa: {
    id: "common.VSTOpetuksenYllapitajallaEiLupaa",
    defaultMessage:
      "Tällä opetuksen yllapitäjällä ei ole voimassa olevaa järjestämislupaa valitulla oppilaitoksella. Hyväksymällä siirrytään luvan tietojen syöttämiseen."
  },
  valitseOppilaitoksenYllapitaja: {
    id: "common.valitseOppilaitoksenYllapitaja",
    defaultMessage: "Valitse oppilaitoksen ylläpitäjä"
  },
  valitseOppilaitostyyppi: {
    id: "common.valitseOppilaitostyyppi",
    defaultMessage: "Valitse oppilaitostyyppi"
  },
  valitseOppilaitos: {
    id: "common.valitseOppilaitos",
    defaultMessage: "Valitse oppilaitos"
  },
  oneYllapitajaMustBeSelected: {
    id: "common.oneYllapitajaMustBeSelected",
    defaultMessage:
      "Sinun tulee valita yksi oppilaitoksen ylläpitäjä, ennen kuin voit jatkaa eteenpäin"
  },
  oneOppilaitosTyyppiMustBeSelected: {
    id: "common.oneOppilaitosTyyppiMustBeSelected",
    defaultMessage:
      "Sinun tulee valita yksi oppilaitostyyppi, ennen kuin voit jatkaa eteenpäin"
  },
  oneOppilaitosMustBeSelected: {
    id: "common.oneOppilaitosMustBeSelected",
    defaultMessage:
      "Sinun tulee valita yksi oppilaitos, ennen kuin voit jatkaa eteenpäin"
  },
  or: {
    id: "common.or",
    defaultMessage: "tai"
  },
  yhteistyovelvoitteet: {
    id: "common.yhteistyovelvoitteet",
    defaultMessage: "Yhteistyövelvoitteet"
  },
  luvanKorjausEpaonnistui: {
    id: "common.luvanKorjausEpaonnistui",
    defaultMessage: "Luvan korjaus epäonnistui"
  },
  valitulleKoulutusmuodolleJarjestajalleKielelleEiloydyPaalupaa: {
    id: "common.valitulleKoulutusmuodolleJarjestajalleKielelleEiloydyPaalupaa",
    defaultMessage:
      "Valitulle koulutusmuodolle, koulutuksen järjestäjälle ja kielelle ei löydy päälupaa"
  },
  tarkasteleTutkintokoulutukseenValmentavanKoulutuksenJarjestamisLupaa: {
    id: "common.tarkasteleTutkintokoulutukseenValmentavanKoulutuksenJarjestamisLupaa",
    defaultMessage:
      "Tarkastele tutkintokoulutukseen valmentavan koulutuksen järjestämislupaa:"
  },
  tarkasteleTuvaLupaanLiittyvaaPaalupaa: {
    id: "common.tarkasteleTuvaLupaanLiittyvaaPaalupaa",
    defaultMessage:
      "Tarkastele koulutuksen järjestäjän {koulutusmuoto} koulutuksen järjestämislupaa:"
  },
  paatosLuonnos: {
    id: "common.paatosLuonnos",
    defaultMessage: "PÄÄTÖSLUONNOS"
  },
  kohdassa4: {
    id: "common.kohdassa4",
    defaultMessage: "kohdassa 4"
  },
  asetaVoimassaoloaika: {
    id: "common.asetaVoimassaoloaika",
    defaultMessage: "Aseta voimassaoloaika"
  },
  lisatietojaTutkinnoista: {
    id: "common.lisatietojaTutkinnoista",
    defaultMessage: "Lisätietoja tutkinnoista"
  },
  lisatietojaKoulutuksista: {
    id: "common.lisatietojaKoulutuksista",
    defaultMessage: "Lisätietoja koulutuksista"
  },
  lisatietojaOpetusJaTutkintokielista: {
    id: "common.lisatietojaOpetusJaTutkintokielista",
    defaultMessage: "Lisätietoja opetus- ja tutkintokielistä"
  },
  lisatietojaOpiskelijavuosista: {
    id: "common.lisatietojaOpiskelijavuosista",
    defaultMessage: "Lisätietoja opiskelijavuosista"
  },
  lisatietojaToimintaAlueesta: {
    id: "common.lisatietojaToimintaAlueesta",
    defaultMessage: "Lisätietoja toiminta-alueesta"
  },
  siteInfoBannerMessage: {
    id: "common.siteInfoBannerMessage",
    defaultMessage: "empty"
  },
  from: {
    id: "common.from",
    defaultMessage: "alkaen"
  },
  until: {
    id: "common.until",
    defaultMessage: "until"
  },
  selectalllangsbtn: {
    id: "common.selectalllangsbtn",
    defaultMessage: "Tutkintokieli englanti kaikille tutkinnoille"
  },
  selectalltutkinnotbtn: {
    id: "common.selectalltutkinnotbtn",
    defaultMessage: "Valitse kaikki tutkinnot"
  }
});
